import router from '@/routers/router'

import api from '@/services/api';
import { alerts } from '@/services/alerts';
import { select2_reset } from '@/services/select';
import { APP, DIR } from '@/services/localhost';


    // NEW
    // NEW






    // TREATMENT ARRAY
        // OBJ_FORMDATA
            export function obj_formData(obj, form = null, namespace = null) {
                var fd = form || new FormData();
                var formKey;
            
                for (var property in obj) {
                    if (obj.hasOwnProperty(property)) {
                        if (namespace) {
                            formKey = namespace + "[" + property + "]";
                        } else {
                            formKey = property;
                        }
            
                        if (typeof obj[property] === "object") {
                            if (Array.isArray(obj[property])) {
                                for (var i = 0; i < obj[property].length; i++) {
                                    obj_formData(obj[property][i], fd, formKey + "[" + i + "]");
                                }
                            } else {
                                obj_formData(obj[property], fd, formKey);
                            }
                        } else {
                            fd.append(formKey, obj[property]);
                        }
                    }
                }
            
                return fd;
            }
        // OBJ_FORMDATA
    // TREATMENT ARRAY







    // NUMBERS
        // PRICE
            export function price($value)
            {
                const options = {
                    style: 'currency',
                    currency: 'BRL'
                }
                let $return = new Intl.NumberFormat('pt-br', options).format($value)

                return $return;
            }
        // PRICE

        // PRICE_
            export function price_($value)
            {
                $value = replace(' ', '', $value);
                $value = replace('R$', '', $value);
                $value = replace(',', '', $value);
                $value = replace('.', '', $value);
                $value = parseInt($value);
                $value = parseInt($value);
                $value = $value/100;
                return $value;
            }
        // PRICE_

        // RAND
            export function rand(min=100000, max=999999)
            {
                let $return = Math.floor(Math.random() * (max - min + 1) + min);
                return $return;
            }
            export function rand_str()
            {
                let $return = (Math.random() + 1).toString(36).substring(7);
                return $return;
            }
        // RAND
    // NUMBERS







    // DATE
        // DATE
            export function data(value, format='d/m/Y', $tipo='-')
            {
                if (value === null || value === '') {
                    return '';
                }

                // Se for timestamp (número)
                if (typeof value === 'number' || /^\d+$/.test(String(value))) {
                    const timestamp = parseInt(String(value));
                    const date = new Date(timestamp * 1000); // JS usa millisegundos
                    return date_format(date, format);
                }

                // Tentar diferentes formatos de entrada
                const formats = [
                    { regex: /^(\d{4})-(\d{2})-(\d{2})$/, parts: ['year', 'month', 'day'] }, // 2025-01-21
                    { regex: /^(\d{2})\/(\d{2})\/(\d{4})$/, parts: ['day', 'month', 'year'] }, // 21/01/2025
                    { regex: /^(\d{2})-(\d{2})-(\d{4})$/, parts: ['day', 'month', 'year'] }, // 21-01-2025
                    { regex: /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/, parts: ['year', 'month', 'day', 'hour', 'minute', 'second'] }, // 2025-01-21 15:23:59
                    { regex: /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/, parts: ['day', 'month', 'year', 'hour', 'minute', 'second'] }, // 21/01/2025 15:23:59
                ];

                for (const fmt of formats) {
                    const match = String(value).match(fmt.regex);
                    if (match) {
                        const dateParts = {};
                        fmt.parts.forEach((part, index) => {
                            dateParts[part] = parseInt(match[index + 1] || '0');
                        });

                        const date = new Date(
                            dateParts.year || new Date().getFullYear(),
                            (dateParts.month || 1) - 1, // JS months are 0-indexed
                            dateParts.day || 1,
                            dateParts.hour || 0,
                            dateParts.minute || 0,
                            dateParts.second || 0
                        );

                        if (!isNaN(date.getTime())) {
                            return date_format(date, format);
                        }
                    }
                }

                return '';
            }

            export function date_format(date, format)
            {
                const pad = (num) => String(num).padStart(2, '0');

                const replacements = {
                    'd': pad(date.getDate()),
                    'j': String(date.getDate()),
                    'm': pad(date.getMonth() + 1),
                    'n': String(date.getMonth() + 1),
                    'Y': String(date.getFullYear()),
                    'y': String(date.getFullYear()).slice(-2),
                    'H': pad(date.getHours()),
                    'G': String(date.getHours()),
                    'i': pad(date.getMinutes()),
                    's': pad(date.getSeconds()),
                };

                return format.replace(/[djmnYyHGis]/g, (match) => replacements[match] || match);
            }
        // DATE

        // DATE
            function date(format, data) {
                var date = new Date(data);
    
                var year = date.getFullYear();
                var month = ('0' + (date.getMonth() + 1)).slice(-2);
                var day = ('0' + date.getDate()).slice(-2);
                var hours = ('0' + date.getHours()).slice(-2);
                var minutes = ('0' + date.getMinutes()).slice(-2);
                var seconds = ('0' + date.getSeconds()).slice(-2);
            
                return format
                    .replace('Y', year)
                    .replace('m', month)
                    .replace('d', day)
                    .replace('H', hours)
                    .replace('i', minutes)
                    .replace('s', seconds);
            }
        // DATE

        // DIVIDE_DATA
            export function divide_data($data, $tipo='-'){
                $data = replace(' ', $tipo, $data);
                $data = replace(':', $tipo, $data);
                $data = replace('T', '-', $data);
                $data = replace('BRT', '-', $data);
                $data = $data.split($tipo);
                $data[3] = $data[3]!=undefined ? $data[3] : 0;
                $data[4] = $data[4]!=undefined ? $data[4] : 0;
                $data[5] = $data[5]!=undefined ? $data[5] : 0;
                return  $data;
            }
        // DIVIDE_DATA

        // HOJE
            export function hoje()
            {
                let date = new Date();
                return`${date.getFullYear()}-${(`00`+(date.getMonth()+1)).slice(-2)}-${(`00`+date.getDate()).slice(-2)}`;
            }
        // HOJE

        // BIRTH
            export function birth()
            {
                let TODAY = new Date()
                let TODAY_15 = new Date(TODAY.getFullYear(), TODAY.getMonth()-(18*12)+1, TODAY.getDate());
                return`${TODAY_15.getFullYear()}-${(`00`+(TODAY_15.getMonth()+1)).slice(-2)}-${(`00`+TODAY_15.getDate()).slice(-2)}`;
            }
        // BIRTH
    // DATE







    // USEFUL
        // STRIP TAGS
            export function strip_tags(input, allowed)
            {
                allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('')
                let tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi
                let commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi
                return input.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1){
                    return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : ''
                })
            }
        // STRIP TAGS

        // REPLACE
            export function replace($de, $para, $txt)
            {
                let $return = ``;
                if($txt){
                    $return = $txt;
                    try {
                        if($txt.indexOf($de) >= 0){
                            let $pos = $txt.indexOf($de);
                            while ($pos > -1){
                                $return = $return.replace($de, $para);
                                $pos = $return.indexOf($de);
                            }
                        }
                    } catch(e) {}
                }
                return $return;
            }
        // REPLACE

        // NAME
            export function name__(name, $tipo=0){ // 0-> So nome; 1->So Sobrenome; 2->x qtd de nome
                if(name == null){
                    return ``;
                }

                let ex = name.split(' ');

                // NOME
                    if($tipo == 0){
                        return ex[0];
                    }
                // NOME

                // SOBRENOME
                    if($tipo == 1){
                        return ex[1]!=null ? ex[1] : ``;
                    }
                // SOBRENOME

                // QTD
                    if($tipo >= 2){
                        let $return = ``;
                        for (let i = 0; i < $tipo; i++) {
                            $return += ex[i] ? `${ex[i]} ` : ``;

                            // SO NOME FOR MENOR QUE X VAR
                                if(ex[i] != null && ex[i].length < 4){
                                    i++;
                                    $return += (ex[i]!=null && ex[i]) ? `${ex[i]} ` : ``;
                                }
                            // SO NOME FOR MENOR QUE X VAR
                        }
                        $return = $return.trim();

                        return $return;
                    }
                // QTD
            }
        // NAME

        // NAME_INI
            export function name_ini(name)
            {
                let $return = ``;

                if(name != null && name){
                    let ex = name.split(' ');

                    $return = ex[0][0];
                    if(ex[1] != null && ex[1][0] != null){
                        $return += ex[1][0];
                    }
                }

                return $return;
            }
        // NAME_INI

        // MINUSCULO
            export function minusculo(str) {
                return str.toLowerCase();
            }
        // MINUSCULO

        // UCFIRST
            export function ucfirst(str) {
                if (!str) return str;
                return str.charAt(0).toUpperCase() + str.slice(1);
            }
        // UCFIRST
       
        // IMPLODE
            export function implode(separator, array)
            {
                if(typeof array === "object"){
                    let array_temp = array
                    array = [];
                    for(let key in array_temp){
                        array.push(key);
                    }
                }
                return array.join(separator);
            }
        // IMPLODE

        // LIMIT
            export function limit(text, limit, ellipsis='...', tirm=1)
            {
                if(text != null && text.length > limit) {
                    text = text.substr(0, limit);
                    if(tirm){
                        text = text.trim();
                    }
                    text += ellipsis;
                }

                return text;
            }
        // LIMIT

        // TITLE
            export function titulo(name, o, s=``)
            {
                let $return = {};

                $return.o = o ? o : ``;
                $return.os = o ? `${o}s` : ``;

                $return.m = name ? name : ``;
                $return.ms = name ? `${name}s` : ``;
                $return.mo = (name && o) ? `${o} ${name}` : ``;
                $return.mos = (name && o) ? `${o}s ${name}s` : ``;

                $return.u = name ? first_letter_uppercase(name): ``;
                $return.us = name ? first_letter_uppercase(`${name}s`): ``;
                $return.uo = (name && o) ? first_letter_uppercase(`${o} ${name}`): ``;
                $return.uos = (name && o) ? first_letter_uppercase(`${o}s ${name}s`): ``;

                //{ m: 'cliente', ms: 'clientes', mo: 'o cliente', mos: 'os clientes', u: 'Cliente', us: 'Clientes', uo: 'O cliente', uos: 'Os clientes' }

                return $return;
            }
        // TITLE

        // FIRST_LETTER_UPPERCASE
            export function first_letter_uppercase(string) 
            {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        // FIRST_LETTER_UPPERCASE

        // RAND
            export function rand__()
            {
                return Math.floor(Math.random() * 100000) + 1;
            }
        // RAND

        // HTTP
            export function http(value)
            {
                if(!value){ return ``; }
				return (!/http/.test(value)) ? `http://${value}` : value;
            }
        // HTTP

        // OPEN__
            export function open__(url, target=`_system`, options=`location=yes`) // _self, _blank, _system
            {
                if($_APP == 2){
                    cordova.InAppBrowser.open(url, target, options);
                } else {
                    window.open(url, `_blank`);
                }
            }
        // OPEN__

        // COPY__
            export function copy__($class, $text='Link Copiado com Sucesso!')
            {
                document.querySelector($class).select();
                let successful = document.execCommand('copy');
                alerts(1, $text);
            }
        // COPY__

        // NO_ACECENT
            export function no_accent($strToReplace)
            {
                let $str_acento = "áàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ";
                let $str_no_accent = "aaaaaeeeeiiiiooooouuuucAAAAAEEEEIIIIOOOOOUUUUC";
                let $return = "";
                for (let i = 0; i < $strToReplace.length; i++){
                    if ($str_acento.indexOf($strToReplace.charAt(i)) != -1){
                        $return += $str_no_accent.substr($str_acento.search($strToReplace.substr(i, 1)), 1);
                    } else {
                        $return += $strToReplace.substr(i, 1);
                    }
                }
                return $return;
            }
        // NO_ACECENT

        // IS_E
            export function is_e($e, $all=0)
            {
                let $return = ``;

                if($e.classList != null){
                    $return = $e;
                } else if($all){
                    $return = document.querySelectorAll($e);
                    if(!$return[0]){
                        $return = '';
                    }
                } else {
                    $return = document.querySelector($e);
                }

                return $return;
            }
        // IS_E

        // BASE64
            export function base_encode($string){
                return btoa($string);
            }
            export function base_decode($string){
                return atob($string);
            }
        // BASE64
    // USEFUL







    // ARRAY
        // MONTH
            export function month($month)
            {
                let $return = ['', 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
                return $return[$month];
            }
            export function month_ab($month)
            {
                let $return = ['', 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
                return $return[$month];
            }
            export function month_select($month=0)
            {
                let $return = [
                            {'id': 1, 'name': 'Janeiro', 'selected': ($month==1)}, 
                            {'id': 2, 'name': 'Fevereiro', 'selected': ($month==2)}, 
                            {'id': 3, 'name': 'Março', 'selected': ($month==3)}, 
                            {'id': 4, 'name': 'Abril', 'selected': ($month==4)}, 
                            {'id': 5, 'name': 'Maio', 'selected': ($month==5)}, 
                            {'id': 6, 'name': 'Junho', 'selected': ($month==6)}, 
                            {'id': 7, 'name': 'Julho', 'selected': ($month==7)}, 
                            {'id': 8, 'name': 'Agosto', 'selected': ($month==8)}, 
                            {'id': 9, 'name': 'Setembro', 'selected': ($month==9)}, 
                            {'id': 10, 'name': 'Outubro', 'selected': ($month==10)}, 
                            {'id': 11, 'name': 'Novembro', 'selected': ($month==11)}, 
                            {'id': 12, 'name': 'Dezembro', 'selected': ($month==12)}
                        ];
                return $return;
            }
        // MONTH

        // STATE
            export function state($state='')
            {
                let $return = [
                            {'id': 'AC', 'name': 'Acre', 'selected': ($state=='AC')}, 
                            {'id': 'AL', 'name': 'Alagoas', 'selected': ($state=='AL')}, 
                            {'id': 'AM', 'name': 'Amazonas', 'selected': ($state=='AM')}, 
                            {'id': 'AP', 'name': 'Amapá', 'selected': ($state=='AP')}, 
                            {'id': 'BA', 'name': 'Bahia', 'selected': ($state=='BA')}, 
                            {'id': 'CE', 'name': 'Ceará', 'selected': ($state=='CE')}, 
                            {'id': 'DF', 'name': 'Distrito Federal', 'selected': ($state=='DF')}, 
                            {'id': 'ES', 'name': 'Espírito Santo', 'selected': ($state=='ES')}, 
                            {'id': 'GO', 'name': 'Goiás', 'selected': ($state=='GO')}, 
                            {'id': 'MA', 'name': 'Maranhão', 'selected': ($state=='MA')}, 
                            {'id': 'MG', 'name': 'Minas Gerais', 'selected': ($state=='MG')}, 
                            {'id': 'MS', 'name': 'Mato Grosso do Sul', 'selected': ($state=='MS')}, 
                            {'id': 'MT', 'name': 'Mato Grosso', 'selected': ($state=='MT')}, 
                            {'id': 'PA', 'name': 'Pará', 'selected': ($state=='PA')}, 
                            {'id': 'PB', 'name': 'Paraíba', 'selected': ($state=='PB')}, 
                            {'id': 'PE', 'name': 'Pernambuco', 'selected': ($state=='PE')}, 
                            {'id': 'PI', 'name': 'Piauí', 'selected': ($state=='PI')}, 
                            {'id': 'PR', 'name': 'Paraná', 'selected': ($state=='PR')}, 
                            {'id': 'RJ', 'name': 'Rio de Janeiro', 'selected': ($state=='RJ')}, 
                            {'id': 'RN', 'name': 'Rio Grande do Norte', 'selected': ($state=='RN')}, 
                            {'id': 'RO', 'name': 'Rondônia', 'selected': ($state=='RO')}, 
                            {'id': 'RR', 'name': 'Roraima', 'selected': ($state=='RR')}, 
                            {'id': 'RS', 'name': 'Rio Grande do Sul', 'selected': ($state=='RS')}, 
                            {'id': 'SC', 'name': 'Santa Catarina', 'selected': ($state=='SC')}, 
                            {'id': 'SE', 'name': 'Sergipe', 'selected': ($state=='SE')}, 
                            {'id': 'SP', 'name': 'São Paulo', 'selected': ($state=='SP')}, 
                            {'id': 'TO', 'name': 'Tocantins', 'selected': ($state=='TO')}, 
                        ];
                return $return;
            }
        // STATE
    // ARRAY







    // OTHERS
        // CITY
            export function city__(FORM, OBJ, zerar_cidade=1, $load=1)
            {
                if(FORM.address_state != null){
                    api(`/city`, { state: FORM.address_state }, (request) => {
                        OBJ.city = request.data.OBJ.city;
                        if(zerar_cidade){
                            FORM.address_city = "";
                        }

                        if($_GLOBAL['city__'] != null && $_GLOBAL['city__']){
                            FORM.address_city = $_GLOBAL['city__'];
                            $_GLOBAL['city__'] = ``;
                        }

                        // SELECT2
                            select2_reset(`.select_city`);
                        // SELECT2
                    }, $load)
                }
            }
        // CITY

        // ZIP_CODE
            export function zip_code__(FORM, OBJ)
            {
                if(FORM.zip_code.length >= 10){
                    api(`/zip_code`, { zip_code: FORM.zip_code }, (request) => {
                        FORM.address = request.rua;
                        FORM.neighborhood = request.bairros;

                        if(FORM.state != undefined){
                            FORM.state = request.estados ? request.estados : ``;
                        } else {
                            FORM.state_text = request.estados ? request.estados : ``;
                        }

                        if(FORM.city != undefined){
                            $_GLOBAL['city__'] = request.cidades ? request.cidades : ``;
                            city__(FORM, OBJ);
                        } else {
                            FORM.city_text = request.cidades ? request.cidades : ``;
                        }

                        // SELECT2
                            if(FORM.state != undefined || FORM.city != undefined){
                                select2_reset(`.select_state`);
                            }
                        // SELECT2
                    })
                }
            }
        // ZIP_CODE
    // OTHERS






    // VERIFICATIONS
        // IS_NUMBER
            export function is_number(value)
            {
                return !isNaN(parseFloat(value)) && isFinite(value);
            }
        // IS_NUMBER
    // VERIFICATIONS







    // CREATE_JS
        export function create_js(url) {
            var script = document.createElement('script');
            script.src = url;
            script.type = 'text/javascript';
            script.onload = function() {
            };
            script.onerror = function() {
                console.error('Erro ao carregar o script ' + url);
            };
            document.head.appendChild(script);
        }
    // CREATE_JS







    // CODIFICATION
        export function crip(value) {
            const substituicoes = {
                '0': 'ENA;;QV',
                '1': 'BA-_VEC',
                '2': 'SD;;XAY',
                '3': 'TO||LUF',
                '4': 'LPD_,WU',
                '5': 'PFA-;YT',
                '6': 'GIV.;ZBX',
                '7': 'MED-;HRF',
                '8': 'RDB;$JY',
                '9': 'TCK#@XFG',
                '/': 'NIP;#TIU',
                ' ': 'YSU@;IR'
            };
            for (const [chave, valor] of Object.entries(substituicoes)) {
                value = value.split(chave).join(valor);
            }
            value = btoa(value);
            return value;
        }
        export function crip_(value) {
            value = atob(value);
            const substituicoes = {
                'ENA;;QV': '0',
                'BA-_VEC': '1',
                'SD;;XAY': '2',
                'TO||LUF': '3',
                'LPD_,WU': '4',
                'PFA-;YT': '5',
                'GIV.;ZBX': '6',
                'MED-;HRF': '7',
                'RDB;$JY': '8',
                'TCK#@XFG': '9',
                'NIP;#TIU': '/',
                'YSU@;IR': ' '
            };
            for (const [chave, valor] of Object.entries(substituicoes)) {
                value = value.split(chave).join(valor);
            }
            return value;
        }
        export function cod(type, txt)
        {
            let $return = txt;
    
            if(type == `asc`){
                $return = replace(`'`, `&#39;`, $return);
                $return = replace(`"`, `&#34;`, $return);
                $return = replace(`´`, `&#180;`, $return);
                $return = replace('`', `&#96;`, $return);
                $return = replace(`?`, `&#63;`, $return);
                $return = replace(`!`, `&#33;`, $return);
                $return = replace(`=`, `&#61;`, $return);
                $return = replace(`<`, `&#60;`, $return);
                $return = replace(`>`, `&#62;`, $return);
            }

            return $return;
        }
    // CODIFICATION







    // APP
        // HREF
            export function href_APP()
            {
                if(APP()){
                    setTimeout(() => {
                        document.querySelectorAll('a[href], a[href__]').forEach($item => {
                            if(!$item.classList.contains('__href__OK')){
                                $item.classList.add('__href__OK');

                                let $link = $item.getAttribute('href');
                                if(!$link) $link = $item.getAttribute('href__');

                                // BLANK
                                    if($item.getAttribute('target') == '_blank'){
                                        $item.addEventListener("click", (e) => {
                                            if($link != '/'){
                                                $link = replace(DIR(), '', $link);
                                            }

                                            e.preventDefault();
                                            if($link && $link != null && $link != undefined && $link != 'null' && $link != 'undefined'){
                                                open__($link);
                                            }
                                        });
                                    }
                                // BLANK

                                // ROUTER
                                    else {
                                        $item.addEventListener("click", (e) => {
                                            if($link != '/'){
                                                $link = replace(DIR(), '', $link);
                                            }

                                            e.preventDefault();
                                            if($link && $link != null && $link != undefined && $link != 'null' && $link != 'undefined'){
                                                router.push($link);
                                            }
                                        });
                                    }
                                // ROUTER
                            }
                        });
                    }, .5);
                }
            }
        // HREF
    // APP
